import { memo, useMemo } from "react";

import { Label } from "@/components/ui/label/label";

type Props = {
	isDayTrip: boolean;
};

export const PlanLabelOfDetailInfoCompositions = memo(({ isDayTrip }: Props) => {
	const labelText = useMemo(() => (isDayTrip ? "日帰りプラン" : "プラン"), [isDayTrip]);
	return <Label text={labelText} variant="green" />;
});
